"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerBmMaskedTextInput = exports.BmMaskedTextInput = void 0;

var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _mask2 = require("@blue/services/utils/mask");

var _element = require("@blue/element");

var _bmFormEvents = require("../../../bm-form-events");

var _textInput = require("./text-input");

var _maskModels = require("./mask-models");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t<style>\n\t\t\tbm-text-input {\n\t\t\t\t--bm-text-input-bold: var(--bm-masked-input-bold);\n\t\t\t}\n\t\t</style>\n\t\t<bm-text-input\n\t\t\t.name=\"", "\"\n\t\t\t.disabled=\"", "\"\n\t\t\t.readonly=\"", "\"\n\t\t\t.required=\"", "\"\n\t\t\t.touched=\"", "\"\n\t\t\t.dirty=\"", "\"\n\t\t\t.value=\"", "\"\n\t\t\t.dataQeId=\"", "\"\n\t\t\t.selectionStart=\"", "\"\n\t\t\t.selectionEnd=\"", "\"\n\t\t\t@bm-form-event=\"", "\"\n\t\t\t@click=\"", "\"\n\t\t\t@focus=\"", "\"\n\t\t></bm-text-input>\n\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BmMaskedTextInput = /*#__PURE__*/function (_bmFormEventDispatche) {
  (0, _inherits2.default)(BmMaskedTextInput, _bmFormEventDispatche);

  var _super = (0, _createSuper2.default)(BmMaskedTextInput);

  function BmMaskedTextInput() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmMaskedTextInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this.clearMalformedValues = true;
    _this.cacheNextValue = false;
    _this.masker = _maskModels.defaultMaskObject.mask;
    _this.unmasker = _maskModels.defaultMaskObject.unmask;
    return _this;
  }

  (0, _createClass2.default)(BmMaskedTextInput, [{
    key: "shouldUpdate",
    value: function shouldUpdate(changedProps) {
      if (changedProps.has('mask')) {
        var prevMask = changedProps.get('mask');

        if (Boolean(prevMask) && !this.mask) {
          this._setMaskerFunctions(null);
        } else if (!prevMask && Boolean(this.mask)) {
          this._setMaskerFunctions(this.mask);
        } else if (Boolean(prevMask) && Boolean(this.mask)) {
          if (changedProps.size === 1 && (0, _maskModels.masksAreEqual)(this.mask, prevMask)) {
            return false;
          }

          this._setMaskerFunctions(this.mask);
        }
      }

      return (0, _get2.default)((0, _getPrototypeOf2.default)(BmMaskedTextInput.prototype), "shouldUpdate", this).call(this, changedProps);
    }
  }, {
    key: "render",
    value: function render() {
      var unmasked = this.unmasker((this.value || '').toString());
      var remasked = this.masker(unmasked, '');

      var _this$getAdjustedCurs = this.getAdjustedCursors(remasked, unmasked),
          selectionStart = _this$getAdjustedCurs.selectionStart,
          selectionEnd = _this$getAdjustedCurs.selectionEnd;

      var masked = this.masker((this.value || '').toString());
      return this.html(_templateObject(), this.name, Boolean(this.disabled), Boolean(this.readonly), Boolean(this.required), Boolean(this.touched), Boolean(this.dirty), masked, this.dataQeId, selectionStart, selectionEnd, this.handleFormEvent, this.handleRefocusEvent, this.handleRefocusEvent);
    }
  }, {
    key: "updated",
    value: function updated() {
      if (this.mask && this.value) {
        var unmasked = this.unmasker((this.value || '').toString());
        var remasked = this.masker(unmasked, '');

        if (this.value === remasked) {
          this.dispatchBmFormEvent({
            type: 'changed',
            data: {
              currentValue: unmasked,
              previousValue: this.value
            }
          });
        }
      }
    }
  }, {
    key: "incrementIndices",
    value: function incrementIndices(masked, unmasked, idx) {
      var unmaskedIdx = 0;
      var maskedIdx = 0;

      for (; unmaskedIdx < idx && unmaskedIdx < unmasked.length && unmaskedIdx < masked.length; ++unmaskedIdx) {
        while (unmasked.charAt(unmaskedIdx) !== masked.charAt(maskedIdx)) {
          maskedIdx++;
        }
      }

      --unmaskedIdx;
      return {
        unmaskedIdx: unmaskedIdx,
        maskedIdx: maskedIdx
      };
    }
  }, {
    key: "getAdjustedCursors",
    value: function getAdjustedCursors(masked, unmasked) {
      if (!unmasked && this.deserializedMask) {
        var _context2;

        var idx = (0, _findIndex.default)(_context2 = this.deserializedMask).call(_context2, function (val) {
          return typeof val !== 'string';
        });
        return {
          selectionEnd: idx,
          selectionStart: idx
        };
      }

      var endPos = 0;

      var element = this._getInputElement();

      if (element) {
        endPos = element.selectionStart || 0;
      }

      if (masked.length !== unmasked.length) {
        var copyEndPos = endPos;

        for (var i = 0, j = 0; i < masked.length && j < unmasked.length; i++) {
          if (masked.charAt(i) === unmasked.charAt(j)) {
            j++;
            endPos = i + 1;

            if (copyEndPos <= endPos) {
              break;
            }
          }
        }
      }

      return {
        selectionStart: endPos,
        selectionEnd: endPos
      };
    }
  }, {
    key: "handleFormEvent",
    value: function handleFormEvent(evt) {
      switch (evt.detail.type) {
        case 'changed':
          return this.handleFormChangedEvent(evt);

        default:
          break;
      }
    }
  }, {
    key: "handleFormChangedEvent",
    value: function handleFormChangedEvent(evt) {
      var currentValue = evt.detail.data.currentValue;
      var unmasked = this.unmasker(currentValue || '');
      var remasked = this.masker(unmasked);
      var reunmasked = this.unmasker(remasked);

      var element = this._getInputElement();

      if (element) {
        var cursor = element.selectionStart || 0;
        element.value = remasked;

        if (this._clickingOutsideData(cursor, remasked, reunmasked)) {
          var _this$getAdjustedCurs2 = this.getAdjustedCursors(remasked, reunmasked),
              selectionEnd = _this$getAdjustedCurs2.selectionEnd,
              selectionStart = _this$getAdjustedCurs2.selectionStart;

          element.selectionEnd = selectionEnd;
          element.selectionStart = selectionStart;
        } else {
          element.selectionEnd = cursor;
          element.selectionStart = cursor;
        }
      }

      var nextValue = this.clearMalformedValues ? reunmasked : unmasked;

      if ((nextValue || '') === (this.value || '')) {
        evt.stopPropagation();
      } else {
        evt.detail.data.currentValue = nextValue;

        if (this.cacheNextValue) {
          this.value = nextValue;
        }
      }
    }
  }, {
    key: "handleRefocusEvent",
    value: function handleRefocusEvent(_) {
      var element = this._getInputElement();

      if (element) {
        var selecting = this._isSelecting(element);

        var masked = element.value;
        var unmasked = this.unmasker(masked);

        if (!selecting && this._clickingOutsideData(element.selectionStart || 0, masked, unmasked)) {
          var _this$getAdjustedCurs3 = this.getAdjustedCursors(masked, unmasked),
              selectionStart = _this$getAdjustedCurs3.selectionStart;

          element.selectionStart = selectionStart;
          element.selectionEnd = selectionStart;
        }
      }
    }
  }, {
    key: "_clickingOutsideData",
    value: function _clickingOutsideData(cursor, masked, unmasked) {
      var _this$incrementIndice = this.incrementIndices(masked, unmasked, unmasked.length),
          maskedIdx = _this$incrementIndice.maskedIdx;

      return cursor > maskedIdx;
    }
  }, {
    key: "_isSelecting",
    value: function _isSelecting(element) {
      return element.selectionStart !== element.selectionEnd;
    }
  }, {
    key: "_getInputElement",
    value: function _getInputElement() {
      var _this$shadowRoot;

      var bmTextInput = (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.querySelector('bm-text-input');
      var element = bmTextInput && bmTextInput.shadowRoot.querySelector('input');
      return element;
    }
  }, {
    key: "_setMaskerFunctions",
    value: function _setMaskerFunctions(serializedMask) {
      var _this2 = this;

      var masker;
      var unmasker;

      if (serializedMask === null) {
        var mask = _maskModels.defaultMaskObject.mask,
            unmask = _maskModels.defaultMaskObject.unmask;
        masker = mask;
        unmasker = unmask;
      } else {
        this.deserializedMask = (0, _mask2.deserialize)(serializedMask);

        var _createMask = (0, _mask2.createMask)(this.deserializedMask),
            _mask = _createMask.mask,
            _unmask = _createMask.unmask;

        masker = function masker(val) {
          return _mask(val, _this2.deserializedMask.length > 0);
        };

        unmasker = _unmask;
      }

      this.masker = masker;
      this.unmasker = unmasker;
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-masked-text-input';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        name: {
          type: String,
          attribute: false,
          reflect: false
        },
        disabled: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        readonly: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        required: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        touched: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        dirty: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        value: {
          type: String,
          attribute: false,
          reflect: false
        },
        mask: {
          type: Array,
          attribute: false,
          reflect: false
        },
        dataQeId: {
          type: String,
          attribute: false,
          reflect: false
        },
        clearMalformedValues: {
          type: Boolean,
          attribute: false,
          reflect: false
        },
        cacheNextValue: {
          type: Boolean,
          attribute: false,
          reflect: false
        }
      };
    }
  }]);
  return BmMaskedTextInput;
}((0, _bmFormEvents.bmFormEventDispatcher)(_element.BlueElement));

exports.BmMaskedTextInput = BmMaskedTextInput;

var registerBmMaskedTextInput = function registerBmMaskedTextInput() {
  (0, _textInput.registerBmTextInput)();
  (0, _element.register)(BmMaskedTextInput);
};

exports.registerBmMaskedTextInput = registerBmMaskedTextInput;
